
import { Nav } from './components/nav'
import { InitPage } from './components/initPage'
import { ScrollAnime } from './components/scrollAnime'
import { Module05Logos } from './modules/module-05-logos'
import { Module06Temoignage } from './modules/module-06-temoignage'
import { Module13Map } from './modules/module-13-map'
import { ArchiveBlog } from './templates/template-archive-blog'
import { Ajax } from './components/ajax'
// import { PopUp } from './components/popup'
// import { DropDown } from './components/dropdown'

class App {
  constructor() {
    // const ajax = new Ajax;
    const nav = new Nav;
    const initPage = new InitPage;
    const scrollAnime = new ScrollAnime;
    // if(document.querySelector('.dropdown')) {  
    //   const dropdown = new DropDown;
    // }
    // if(document.querySelector('.popup')) {  
    //   const popup = new PopUp;
    // }

    if(document.querySelector('.module-05-logo')) {
      const module05Logos = new Module05Logos;
    }
    if(document.querySelector('.module-06-temoignage')) {
      const module06Temoignage = new Module06Temoignage;
    }
    if(document.querySelector('.module-13-map')) {
      const module13Map = new Module13Map;
    }
    if(document.querySelector('.template-archive-blog')) {
      const archiveBlog = new ArchiveBlog;
    }
  }
}
export { App }

window.onload = function() {
  let app = new App();
};
